import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import designSystem from "./plugins/design-system";
import setupHttp from "./http";
import { setupVersionCheck } from "./version";
import { can } from "./auth";
import { setupPwa } from "./pwa";
import { listenPushChanges } from "./push";

Vue.use(designSystem)

// Доступ к страницам и функциям в шаблонах: v-if="$can('orders.assign')" (права настраивает экран «Пользователи»).
Vue.prototype.$can = can

// Адрес API: по умолчанию боевой; для разработки задаётся в .env.development.local (VUE_APP_API_URL).
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "https://api.strtagil.ru/";
setupHttp(router)
setupVersionCheck(router)
// Приложение (PWA): сервис-воркер и установка на экран; push-уведомления привязываются после входа (см. AppShell)
setupPwa()
listenPushChanges()
// axios.defaults.baseURL = "http://localhost:8080/";
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
